import { Component, OnInit } from '@angular/core';
import { UnityService } from 'src/app/services/unity.service';
import { Unity } from 'src/app/models/unity';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CostUnityRecord } from 'src/app/models/cost-unity-record';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-unities-report',
  templateUrl: './unities-costs-report.component.html',
  styleUrls: ['./unities-costs-report.component.css']
})
export class UnitiesCostsReportComponent implements OnInit {

  unities:Unity[] = [];
  unitiesAll:Unity[] = [];
  unity:Unity = new Unity();
  costs:CostUnityRecord[] = [];
  updateCosts:boolean = false;
  loading:boolean = false;
  expand:boolean = false;

  //filters
  customers:string[] = [];
  customer:string = null;
  unitTypes:string[] = [];
  unitType:string = null;
  ubications:string[] = [];
  ubication:string = null;

  updown:number = 1;
  sorted:string = '';

  constructor(private unityServ:UnityService, private modal:NgbModal, private toastr:ToastrManager, private utl:UtilitiesService, private auth:AuthService) { }

  ngOnInit() {
    this.loading = true;
    this.unityServ.getUnities().then(unities => {
      this.unities = unities.filter(un => un.unit_type.name != 'Contratistas');

      for(let i = 0; i < this.unities.length; i++) {
        let un = this.unities[i];
        un.insurance_expiration_date = un.insurance_expiration_date ? new Date(un.insurance_expiration_date + " 10:00:00") : null;
        un.insurance_issue_date = un.insurance_issue_date ? new Date(un.insurance_issue_date + " 10:00:00") : null;
        un.physical_mechanics_date = un.physical_mechanics_date ? new Date(un.physical_mechanics_date + " 10:00:00") : null;
        un.physical_mechanics_date_2 = un.physical_mechanics_date_2 ? new Date(un.physical_mechanics_date_2 + " 10:00:00") : null;
        un.pollutant_date = un.pollutant_date ? new Date(un.pollutant_date + " 10:00:00") : null;
        un.pollutant_date_2 = un.pollutant_date_2 ? new Date(un.pollutant_date_2 + " 10:00:00") : null;

        //add filters
        this.utl.createFilter(this.customers, un.customer.comercial_name);
        this.utl.createFilter(this.ubications, un.ubication);
        this.utl.createFilter(this.unitTypes, un.unit_type.name);
      }
      this.unitiesAll = this.unities;

      this.loading = false;
    });
    this.updateCosts = this.auth.can("update-unity-costs");
  }

  filterAll() {
    this.unities = this.utl.filterBy(this.utl.filterBy(this.utl.filterBy(this.unitiesAll, 'customer.comercial_name', this.customer ? [this.customer] : []), 'unit_type.name', this.unitType ? [this.unitType] : []), 'ubication', this.ubication ? [this.ubication] : []);
  }

  select(m, u) {
    this.unity = u;
    this.modal.open(m, {size: 'lg'});
  }

  selectCosts(m, u) {
    this.unity = u;
    this.loading = true;
    this.unityServ.getCosts(u).then(costs => {
      this.costs = costs;
      this.loading = false;
      this.modal.open(m, {size: 'lg'});
    });
  }

  sort(param) {
    this.unities = this.unities.sort(this.utl.dynamicSort((this.updown == 1 ? '' : '-') + param));
    this.updown = this.updown*-1;
    this.sorted = param;
  }

  compareDate(date:Date) {
    if (date) {
      let comparableDate = new Date();
      comparableDate.setDate(comparableDate.getDate() - 6);
      return comparableDate.getTime() >= date.getTime();
    }

    return false;
  }

  saveCosts() {
    this.loading = true;
    this.unityServ.postCosts(this.unity).then(resp => {
      this.toastr.successToastr('Actualizado correctamente');
      this.loading = false;
    }).catch(e => {
      this.toastr.errorToastr('Algo fue mal');
      this.loading = false;
    });
  }

  download(type) {
    window.open(environment.baseUrl + '/' + type + '/unities-cost', '_blank')
  }
}
